module.exports = __webpack_public_path__ + "static/img/Nic.28dfa2e.jpg";